import { warn } from './console-wrapper';
import { isObject } from './type-guards';
import { CdpVersion, EmittedEvents } from '../enums';
/**
 * For original slack discussion on this limit
 * @see {@link https://square.slack.com/archives/C05V7E1EGKD/p1697651922236619 }
 */
export const MAX_ACCEPTABLE_COLUMNS = 30;
export function numberOfColumns(eventProps) {
    let columns = 1;
    if (isObject(eventProps)) {
        for (const value of Object.values(eventProps)) {
            columns += numberOfColumns(value);
        }
    }
    return columns;
}
/**
 * Some upstream data sources flatten nested objects from event properties, creating
 * many individual columns in database tables, to make the data easier to query.
 * When large numbers of unique keys are included in an event's payload, this can lead
 * to hundreds or thousands of columns being created, exhausting the database's capacity.
 *
 * This has resulted in a SEV:
 * @see {@link https://docs.google.com/document/d/1AxmMPTWYGEo8I5iKpjnW5_HqkgiMwcX0haTlrtpBte8/edit?usp=sharing }
 *
 * The only events being captured here are V1 track events.
 */
export function warnAboutExcessiveColumns(message) {
    const columns = numberOfColumns(message.properties) - 1;
    if (columns > MAX_ACCEPTABLE_COLUMNS) {
        warn(`event "${message.eventName}" will create ${columns} columns in some upstream database tables`);
        window.dispatchEvent(new CustomEvent(EmittedEvents.ExcessiveColumns, {
            detail: { message, columns, cdpVersion: CdpVersion.V1 },
        }));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVlcC1uZXN0aW5nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NkcC91dGlscy9kZWVwLW5lc3RpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3pDLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDekMsT0FBTyxFQUFFLFVBQVUsRUFBRSxhQUFhLEVBQUUsTUFBTSxVQUFVLENBQUM7QUFHckQ7OztHQUdHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQUcsRUFBRSxDQUFDO0FBRXpDLE1BQU0sVUFBVSxlQUFlLENBQUMsVUFBbUI7SUFDakQsSUFBSSxPQUFPLEdBQUcsQ0FBQyxDQUFDO0lBQ2hCLElBQUksUUFBUSxDQUFDLFVBQVUsQ0FBQyxFQUFFLENBQUM7UUFDekIsS0FBSyxNQUFNLEtBQUssSUFBSSxNQUFNLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxFQUFFLENBQUM7WUFDOUMsT0FBTyxJQUFJLGVBQWUsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNwQyxDQUFDO0lBQ0gsQ0FBQztJQUNELE9BQU8sT0FBTyxDQUFDO0FBQ2pCLENBQUM7QUFFRDs7Ozs7Ozs7OztHQVVHO0FBQ0gsTUFBTSxVQUFVLHlCQUF5QixDQUFDLE9BQTBCO0lBQ2xFLE1BQU0sT0FBTyxHQUFHLGVBQWUsQ0FBQyxPQUFPLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ3hELElBQUksT0FBTyxHQUFHLHNCQUFzQixFQUFFLENBQUM7UUFDckMsSUFBSSxDQUNGLFVBQVUsT0FBTyxDQUFDLFNBQVMsaUJBQWlCLE9BQU8sMkNBQTJDLENBQy9GLENBQUM7UUFDRixNQUFNLENBQUMsYUFBYSxDQUNsQixJQUFJLFdBQVcsQ0FBQyxhQUFhLENBQUMsZ0JBQWdCLEVBQUU7WUFDOUMsTUFBTSxFQUFFLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxVQUFVLEVBQUUsVUFBVSxDQUFDLEVBQUUsRUFBRTtTQUN4RCxDQUFDLENBQ0gsQ0FBQztJQUNKLENBQUM7QUFDSCxDQUFDIn0=